import { ChecksumAddress } from '@silo/types';
import router from 'next/router';

export enum PATH {
  HOME = '/',
  MARKETS = HOME,
  DASHBOARD = '/dashboard',
}

export const goTo = (where: PATH) => {
  router.push({
    pathname: where,
  });
};

export const siloLink = (siloAddress: ChecksumAddress) => `/silo/${siloAddress}`;
const siloWithScreen = (screen: string) => (siloAddress: ChecksumAddress, asset?: ChecksumAddress) =>
  siloLink(siloAddress) + `?screen=${screen}` + (asset ? `&${siloPageAssetQueryStringKey(screen)}=${asset}` : '');
export const depositLink = siloWithScreen('deposit');
export const borrowLink = siloWithScreen('borrow');
export const withdrawLink = siloWithScreen('withdraw');
export const repayLink = siloWithScreen('repay');

export const siloPageAssetQueryStringKey = <T extends string>(screen: T): `${T}Asset` => `${screen}Asset`;
